import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { Portal } from 'components/utility/portal'
import { inIframe } from 'lib/utilities/dom'

export default function LoginAlertModal({ open = false, onClose = () => {}, redirectUrl = '' }) {
  const [show, setShow] = useState(open)

  useEffect(() => {
    setShow(open)
  }, [open])

  const handleNavigate = () => {
    if (!inIframe())
      return window.location = redirectUrl

    window.open('https://www.domecile.com/users/login', "_blank").focus()
  }

  return (
    <Portal>
      <div className={clsx('login-alert-overlay dome-full-width dome-full-height', show && 'show')}>
        <div className="dome-full-width dome-full-height dome-d-flex dome-align-center dome-justify-center">
          <div className="login-alert-container dome-d-flex dome-flex-column dome-gap24">
            <div className="dome-d-flex dome-flex-column dome-gap12">
              <i style={{ fontSize: '45px' }} class="fa-thin fa-arrow-right-to-bracket dome-color-dark-green"></i>
              <span className="dome-h2 dome-color-dark-green">login to continue</span>
            </div>
            <span style={{ marginTop: '24px' }} className="dome-p1 dome-text-w300 dome-color-dark-grey">
              Only logged in users may request questionnaire.
            </span>
            <div className="dome-d-flex dome-justify-between">
              <div className="dome-d-flex dome-gap6 dome-align-center">
                <i className="fa-regular fa-xmark dome-color-med-grey" />
                <button type="button" onClick={onClose} className="dome-btn dome-btn-link dome-btn-link-med-grey">
                  cancel
                </button>
              </div>
              <button type="button" onClick={handleNavigate} className="btn-base btn-dark-green">
                log in / sign up
              </button>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  )
}
